<template>
  <v-container class="pa-0">
    <Subheader dense title="Guideline Details" no-search />

    <v-card>
      <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
        <v-card-text>
          <v-layout row wrap pl-3 pr-3>
            <v-flex xs12>
              <v-text-field label="Guideline Long Name" v-model="guidelineData.GuidelineLongName" :rules="guidelineLongNameRules"></v-text-field>
              <v-text-field label="Guideline short Name" v-model="guidelineData.GuidelineName" :rules="guidelineShortNameRules"></v-text-field>
              <v-combobox ref="category" label="Category" v-model="guidelineData.Category" :items="guidelinesCategory" :rules="categoryRules"></v-combobox>
              <v-select label="Media Types" v-model="guidelineData.Medias" :items="mediaTypeList" multiple item-text="Name" :rules="mediaTypeRules" return-object></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="success" @click="clickSave()">
            <v-icon class="mr-1">done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-card>
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar" auto-height>
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import Subheader from '@/components/generic/Subheader'

  import { AddGuidelineActionName } from '@/components/mixins/GuidelinesManageUtil'
  import { createNamespacedHelpers } from 'vuex'
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  export default {
    components: {
      Subheader,
    },
    props: {
      actionName: {
        type: String,
        default: '',
      },
      currentGuideline: {
        type: Object,
        default: () => {},
      },
      isAddpageForm: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        valid: true,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        guidelineData: {},
        originalData: {},

        categoryRules: [
          (v) => !!v || 'Category is required',
        ],
        mediaTypeRules: [
          (v) => (!!v && !!v.length) || 'Media Type is required',
        ],
      }
    },
    mounted() {
      this.setGuidelineData()
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['isTenantAdmin', 'currentUserGroup']),
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines', 'guidelinesCategory']),

      guidelineLongNameRules() {
        if (this.actionName == AddGuidelineActionName) {
          return [
            (v) => !!v || 'Guideline Long Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineLongName == v) || 'This Guideline Long Name already exists',
          ]
        } else {
          return [
            (v) => !!v || 'Guideline Long Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineLongName == v && x.GuidelineLongName != this.currentGuideline
              .GuidelineLongName) || 'This Guideline Long Name already exists',
          ]
        }
      },
      guidelineShortNameRules() {
        if (this.actionName == AddGuidelineActionName) {
          return [
            (v) => !!v || 'Guideline Short Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineName == v) || 'This Guideline Short Name already exists',
          ]
        } else {
          return [
            (v) => !!v || 'Guideline Short Name is required',
            (v) => !this.Guidelines.find(x => x.GuidelineName == v && x.GuidelineName != this.currentGuideline.GuidelineName) ||
            'This Guideline Short Name already exists',
          ]
        }
      },
    },
    watch: {
      currentGuideline() {
        this.setGuidelineData()
      },
      snackbar() {
        if (this.isAddpageForm && !this.snackbar) {
          this.$router.push({
            name: 'guidelinesDetail',
            params: {
              name: this.guidelineData.GuidelineName,
            },
          })
        }
      },
    },
    methods: {
      ...guidelines.mapActions(['postAddNewGuideline', 'postUpdateGuideline', 'postAddGuidelineTenant']),
      startSnack(snackColor, snackMessage) {
        this.snackMessage = snackMessage
        this.snackColor = snackColor
        this.snackbar = true
      },
      setGuidelineData() {
        if (this.actionName != AddGuidelineActionName && !this.isAddpageForm) {
          this.guidelineData = JSON.parse(JSON.stringify(this.currentGuideline))
          let arr = []
          this.guidelineData.Medias.forEach(e => {
            let media = this.mediaTypeList.find(x => x.Id == e.MediaTypeId)
            if(media) {
              arr.push(media)
            }            
          })
          this.guidelineData.Medias = arr
          this.originalData = this.guidelineData
        }
      },
      clickSave() {
        if (this.$refs.form.validate()) {
          this.guidelineData.Category = this.$refs.category.internalSearch.trim()
          let options = {
            data: {
              Id: this.guidelineData.Id ? this.guidelineData.Id : null,
              Name: this.guidelineData.GuidelineName,
              LongName: this.guidelineData.GuidelineLongName,
              Category: this.guidelineData.Category,
              MediaTypes: this.guidelineData.Medias,
              Standards: this.guidelineData.Standards,
              TenantGuidelines: this.guidelineData.TenantGuidelines,
            },
            addSuccessCb: () => {
              this.startSnack('success', this.$t('GuidelinesDetailForm.addSuccessMsg', { msg: this.guidelineData.GuidelineName }))
              setTimeout(() => {
                this.$router.push({
                  name: 'guidelinesDetail',
                  params: {
                    name: this.guidelineData.GuidelineName,
                  },
                })
              }, 1500)
            },
            updateSuccessCb: () => {
              this.startSnack('success', this.$t('GuidelinesDetailForm.updateSuccessMsg', { msg: this.guidelineData.GuidelineName }))
              if (this.currentGuideline.GuidelineName != this.guidelineData.GuidelineName) {
                this.$router.push({
                  name: 'guidelinesDetail',
                  params: {
                    name: this.guidelineData.GuidelineName,
                  },
                })
              }
            },
            failedCb: (err) => {
              this.startSnack('error', err)
            },
          }
          if (this.isAddpageForm) {
            this.postAddNewGuideline(options)
          } else {
            this.postUpdateGuideline(options)
          }
        }
      },

    },
  }
</script>

<style scoped>
  .backgroundColor {
    background-color: #fafafa;
  }

  .removePadding {
    padding: 0px;
  }

  .centerBtn {
    margin: 0 auto;
    display: block;
    width: 40%;
  }
</style>